'use client';

/**
 * CardSectionHeader — the mono-caps label with a 1px-ink bottom
 * hairline that heads a section inside a <Card> (detail modals,
 * steps/tips blocks, the project-view NOTES block).
 *
 * Recipe: JetBrains Mono, 9px / fw 700 / 0.16em / uppercase,
 * color var(--ink-2), padding 8px 12px, 1px solid var(--ink)
 * bottom border.
 *
 * Flagged in CLAUDE.md as a future-primitive candidate (8 inline
 * copies across the app) — extracted in the 1394–1411 review sweep.
 * New call sites should use this; the remaining inline copies can be
 * migrated opportunistically when their files are next touched.
 */

import type { CSSProperties, ReactNode } from 'react';

export type CardSectionHeaderProps = {
  children: ReactNode;
  style?: CSSProperties;
};

export function CardSectionHeader({ children, style }: CardSectionHeaderProps) {
  return (
    <p
      style={{
        fontFamily: 'var(--font-mono)',
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: 'var(--ink-2)',
        padding: '8px 12px',
        borderBottom: '1px solid var(--ink)',
        margin: 0,
        ...style,
      }}
    >
      {children}
    </p>
  );
}
